import { Component } from '@angular/core';

/**
 * Footer region of `upp-panel`. Projects arbitrary content (actions, tab bar, etc.).
 */
@Component({
    selector: 'upp-panel-footer',
    templateUrl: './upp-footer.html',
    styleUrls: ['./upp-footer.scss'],
})
export class UppPanelFooterComponent {
    // nothing to do
}
